import type { ApiProxyClient } from '../../types';
import { activateOffer } from './activateOffer';
import { getAllLoyaltyData } from './getAllLoyaltyData';
import { getLoyaltyPoints } from './getLoyaltyPoints';
import { getMemberPoints } from './getMemberPoints';
import { getOffers } from './getOffers';
import { getPointsHistory } from './getPointsHistory';

export const loyaltyApi: ApiProxyClient['loyalty'] = {
    activateOffer,
    getAllLoyaltyData,
    getLoyaltyPoints,
    getMemberPoints,
    getOffers,
    getPointsHistory,
};
